import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import { MdPause } from 'react-icons/md';
import { FaPlayCircle, FaTrash } from 'react-icons/fa';
import { IoIosMore } from 'react-icons/io';
import { PromoterOfferDto } from 'legacy/events/types';
import EditPromoterStatusModal from '../EditPromoterStatusModal';

type OfferActionModalProps = {
  offer: PromoterOfferDto;
  onClose: () => void;
  handleDeletePromoterOffer: () => void;
  handleOfferDetails: () => void;
};

const OfferActionModal: React.FC<OfferActionModalProps> = ({
  offer,
  onClose,
  handleDeletePromoterOffer,
  handleOfferDetails
}) => {
  const { t } = useTranslation(['events']);
  const isPaused = !offer.isActive;
  const hasActivePromoters = (offer?.activePromoters ?? 0) > 0;
  const [isPausePromoterModalOpen, setIsPausePromoterModalOpen] =
    useState(false);

  const handlePauseOffer = () => {
    setIsPausePromoterModalOpen(true);
  };

  return (
    <>
      <Modal
        visible
        autoHeight
        onClose={onClose}
        type={ModalType.SMALL}
        title={t('settings.promoterOffers.modals.offerActions.title')}
        icon={<IoIosMore size={20} />}
        renderFooter={() => (
          <div
            className={`justify-center self-center items-center my-1 ${
              hasActivePromoters
                ? 'text-gray-500 cursor-not-allowed opacity-70'
                : 'text-[#A4332A] cursor-pointer'
            }`}
            onClick={hasActivePromoters ? undefined : handleDeletePromoterOffer}
          >
            <div className="flex items-center justify-center text-base font-bold">
              <FaTrash size={14} className="mr-2" />
              {t('settings.promoterOffers.modals.offerActions.deleteOffer')}
            </div>
          </div>
        )}
      >
        <div className="mx-4">
          <div className="flex flex-col gap-2 mt-6">
            <Button
              type={ButtonType.Inverted}
              onClick={handleOfferDetails}
              icon={
                <img
                  src="/img/events/create/offer-blue.svg"
                  height={16}
                  width={16}
                />
              }
            >
              {t('settings.promoterOffers.modals.offerActions.offerDetails')}
            </Button>
          </div>
          <div className="flex flex-col gap-2 mt-6">
            <Button
              type={ButtonType.Inverted}
              onClick={handlePauseOffer}
              icon={
                isPaused ? <FaPlayCircle size={20} /> : <MdPause size={20} />
              }
            >
              {isPaused
                ? t('settings.promoterOffers.modals.offerActions.resumeOffer')
                : t('settings.promoterOffers.modals.offerActions.pauseOffer')}
            </Button>
          </div>
        </div>
      </Modal>
      {isPausePromoterModalOpen && (
        <EditPromoterStatusModal
          onClose={() => setIsPausePromoterModalOpen((prev) => !prev)}
          eventId={offer.eventId}
          offerId={offer.id}
          isActive={offer.isActive}
          onSuccess={() => {
            setIsPausePromoterModalOpen(false);
            onClose();
          }}
        />
      )}
    </>
  );
};

export default OfferActionModal;
